<template>
  <div class="mb-3">
    <text-input v-model="form.name" :error="form.errors.name" label="Airport Name" />
    <text-input v-model="form.island_city" :error="form.errors.island_city" label="Island / City" />
    <text-input v-model="form.city" :error="form.errors.code" label="Airport City" />
    <SelectCountry v-model="form.country" :error="form.errors.country" label="Airport Country" />
    <text-input v-model="form.iata" :error="form.errors.iata" label="Airport IATA" />
    <text-input v-model="form.icao" :error="form.errors.icao" label="Airport ICAO" />
  </div>
</template>

<script>
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import SelectCountry from '@/Shared/SelectCountry'

export default {
  name: 'AirportForm',
  components: {
    SelectInput,
    SelectCountry,
    TextInput,
  },
  props: {
    form: Object
  }
}
</script>

<style>

</style>
